import { css, type Theme } from '@emotion/react';

import { CARD_PROGRESS_HEIGHT_OFFSET, CARD_VARIANTS } from './constants';

export const cardStyle = (theme: Theme) => css`
  background-color: ${theme.colors.gray[0]};

  border-radius: 8px;

  border: 1px solid ${theme.colors.gray[100]};

  &.${CARD_VARIANTS.DANGER} {
    background-color: ${theme.colors.danger[50]};
    border: 1px solid ${theme.colors.danger[100]};
  }

  &.${CARD_VARIANTS.DISABLED} {
    background-color: ${theme.colors.gray[50]};
    border: 1px solid ${theme.colors.gray[100]};
  }

  &.${CARD_VARIANTS.NEUTRAL} {
    background-color: ${theme.colors.gray[0]};
    border: 1px solid ${theme.colors.gray[100]};
  }

  &.${CARD_VARIANTS.PRIMARY} {
    background-color: ${theme.colors.primary[25]};
    border: 1px solid ${theme.colors.primary[100]};
  }

  &.${CARD_VARIANTS.SUCCESS} {
    background-color: ${theme.colors.success[25]};
    border: 1px solid ${theme.colors.success[100]};
  }

  &.${CARD_VARIANTS.WARNING} {
    background-color: ${theme.colors.warning[25]};
    border: 1px solid ${theme.colors.warning[100]};
  }

  &.${CARD_VARIANTS.SECONDARY} {
    background-color: ${theme.colors.secondary[25]};
    border: 1px solid ${theme.colors.secondary[100]};
  }

  &.${CARD_VARIANTS.TERTIARY} {
    background-color: ${theme.colors.tertiary[25]};
    border: 1px solid ${theme.colors.tertiary[100]};
  }
`;

export const cardBorderStyle = (theme: Theme, borderColor: string, progress: number) => css`
  &::before {
    content: '';
    display: block;
    width: 100%;
    height: ${CARD_PROGRESS_HEIGHT_OFFSET}px;
    background-image: linear-gradient(
      to right,
      ${borderColor} 0%,
      ${borderColor} ${progress * 100}%,
      ${theme.colors.gray[50]} ${progress * 100}%,
      ${theme.colors.gray[50]} 100%
    );

    border-radius: 4px 4px 0 0;
  }
`;
